import { createApi } from '@reduxjs/toolkit/query/react';
import { publicBaseQuery } from '../baseQuery';

export const authorisationApi = createApi({
	reducerPath: 'authorisationApi',
	tagTypes: ['AUTHORISATION'],
	baseQuery: publicBaseQuery,
	endpoints: (builder) => ({
		getUserFirebaseToken: builder.query({
			query: () => ({
				url: process.env.REACT_APP_FIREBASE_CREATE_TOKEN,
				method: 'POST',
				body: {},
			}),
			transformResponse: (response) => ({
				fbToken: response?.fbToken || response?.token || null,
			}),
			providesTags: ['AUTHORISATION'],
			// Custom tokens encode claims (e.g. brokerage); avoid long-lived client cache.
			keepUnusedDataFor: 0,
		}),
	}),
});

export const { useGetUserFirebaseTokenQuery } = authorisationApi;
